import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { renderToStaticMarkup } from 'react-dom/server';
import { getRandomID } from '@mdc/services';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@mdc/constants';
import { InternalLink } from '@mdc/ui';

import './FileSanitizationStats.scss';

const TYPES = {
    BEFORE: 'before_sanitization',
    AFTER: 'after_sanitization'
};

const FileSanitizationStats = ({ value }) => {
    const data = value?.data;
    const type = value?.type;
    const [tooltipId] = useState(getRandomID(9));
    const { t } = useTranslation();

    const classNames = classnames({
        'fileSanitizationStats': true,
        'beforeSanitization': type === TYPES.BEFORE,
        'afterSanitization': type === TYPES.AFTER
    });

    const scanUrl = useMemo( () => {
        const URLS = {
            [TYPES.BEFORE]: `${ROUTES.results.href}/file/${data?.data_id}/regular/multiscan`,
            [TYPES.AFTER]: `${ROUTES.results.href}/file/${data?.data_id}/regular/overview`
        };

        return URLS[type];
    }, [data]);

    const navigateTo = (href) => {
        if (type === TYPES.BEFORE) {
            return <InternalLink url={href} text={t('before CDR')}/>;
        }
        return <InternalLink url={href} text={t('after CDR')}/>;

    };

    const tooltipContent = useMemo(() => {
        return <p>{t('Click to view file processing details')} {navigateTo(scanUrl) }</p>;
    }, [type, scanUrl]);

    const getTooltipPosition = (
        position,
        currentEvent,
        currentTarget,
        node
    ) => {
        const tooltipRect = node?.getBoundingClientRect?.();
        const elemRect = currentTarget?.getBoundingClientRect?.();

        if (!elemRect || !tooltipRect) {
            return {};
        }
        const heightDiff = tooltipRect.height - elemRect.height;

        const left = elemRect.left - tooltipRect.width + 15;
        const top  = heightDiff > 0 ? elemRect.top - (heightDiff / 2) : elemRect.top;

        return { top, left };
    };

    const tooltipClasses = classnames('fileSanitizationStatsTooltip', {
        'beforeSanitization': type === TYPES.BEFORE,
        'afterSanitization': type === TYPES.AFTER
    });

    return (
        <>
            <a href={scanUrl} className={classNames} data-tip={renderToStaticMarkup(tooltipContent)} data-for={tooltipId}>
                <div>{`${data.total_detected} / ${data.total_avs}`}</div>

            </a>
            <ReactTooltip className={tooltipClasses} id={tooltipId} place="left" html={true} overridePosition={getTooltipPosition}/>
        </>
    );
};

FileSanitizationStats.propTypes = {
    value: PropTypes.object.isRequired
};

export default FileSanitizationStats;
